import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackAddToCartParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackAddToCart";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackAddToCart = (
    parameters: PartialSpecific<TrackAddToCartParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventListTrackerHook(ga.track.addToCart, parameters, options);
};

export default useTrackAddToCart;
